module.exports = __webpack_public_path__ + "img/curas4.1e7dbe7c.jpg";